import React from 'react';
import './DropdownLink.scss';
import '../navLink/NavLink.scss';
import { NavLink } from '../navLink';
import { useLocation } from 'react-router-dom';
import { View, useIsMobile } from 'hooks';

interface LinkAttributes {
  label: string;
  to: string;
}

interface DropdownLinkProps {
  label: string;
  links: Array<LinkAttributes>;
  style?: Object;
}

function DropdownLink({ label, links, style = {} }: DropdownLinkProps) {
  const { view } = useIsMobile();
  const location = useLocation();
  const selected =
    links.filter((link) => link.to === location.pathname).length > 0;
  return (
    <div
      className={`dropdownLink navLink ${
        selected ? 'selectedNavLink' : 'unSelectedNavLink'
      }`}
    >
      {label}
      {view === View.Desktop && (
        <span style={{ fontSize: 'x-small' }}>&nbsp;&#9660;</span>
      )}
      {view === View.Tablet && (
        <span className="dropdownLinkArrow rightArrow">&nbsp;&#8250;</span>
      )}
      <div className="dropdownButtonLinks">
        {links.map((link, index) => (
          <NavLink key={index} label={link.label} to={link.to} style={style} />
        ))}
      </div>
    </div>
  );
}

export default DropdownLink;
